import React from "react";
import { useModal } from "../../context/ModalContext";

export default function Flagship() {
    const { openModal } = useModal();
    return (
        <section className="container sec-svc-flagship">
            <div className="flagship">
                <span className="blob"></span>
                <div className="pos-rel">
                    <span className="badge">FLAGSHIP SERVICE</span>
                    <h2>Custom Solutions Development</h2>
                    <p>
                        Bespoke platforms, internal tools and integrations, architected around your exact workflow and built to scale. When off-the-shelf can't keep up, this is what we do best.
                    </p>
                    <div className="checks">
                        <div className="check">
                            <span className="tick tick--orange">
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </span>
                            <span>Web platforms & portals</span>
                        </div>
                        <div className="check">
                            <span className="tick tick--orange">
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </span>
                            <span>Process automation</span>
                        </div>
                        <div className="check">
                            <span className="tick tick--orange">
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </span>
                            <span>API integrations</span>
                        </div>
                        <div className="check">
                            <span className="tick tick--orange">
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </span>
                            <span>Scalable architecture</span>
                        </div>
                    </div>
                    <button className="btn btn-primary" onClick={openModal} type="button">Start a custom project</button>
                </div>
                <div className="art">
                    <div className="frame"></div>
                    <div className="card">
                        <div className="dotsrow">
                            <span></span>
                            <span></span>
                        </div>
                        <div className="line"></div>
                        <div className="line short"></div>
                        <div className="row">
                            <i className="sw-orange"></i>
                            <i className="sw-line"></i>
                            <i className="sw-navy"></i>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
